import { type QueryClient, useQuery } from '@tanstack/react-query'

import { imageProvidersApi } from '../../data/api/image-providers.api'
import type { ProblemDetailsError } from '../../data/types/ProblemDetails'

export const imageProvidersKeys = {
  all: ['imageproviders'] as const,
}

export function useImageProviders(enabled?: boolean) {
  return useQuery({
    queryKey: imageProvidersKeys.all,
    queryFn: () => imageProvidersApi.list().then((r) => r.data),
    enabled,
  })
}

export function refreshImageProvidersOnInvalidProviderError(
  error: unknown,
  queryClient: QueryClient,
) {
  if (error === null || typeof error !== 'object') return false

  const problemDetails = (error as Partial<ProblemDetailsError>).problemDetails
  if (problemDetails?.label !== 'InvalidImageProvider') return false

  void queryClient.invalidateQueries({ queryKey: imageProvidersKeys.all })
  return true
}
